import { render } from "./PRTimeline.vue?vue&type=template&id=2bf91a78"
import script from "./PRTimeline.vue?vue&type=script&lang=js"
export * from "./PRTimeline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__